module.exports = __webpack_public_path__ + "img/FGC.7ada7fbd.svg";